// extracted by mini-css-extract-plugin
export default {"page1Primary":"Page1_page1Primary__ZMoY4","Page1Parent":"Page1_Page1Parent__GoAyX","Page1Child":"Page1_Page1Child__nZ71O","page1Sister":"Page1_page1Sister__NXk+h"};